import React, { Component } from 'react'
import { connect } from 'react-redux'
import { path } from 'ramda'
import Uppy from '@uppy/core'
import VideoUploadDragDrop from 'Components/VideoUpload/VideoUploadDragDrop'
import { ProgressBar } from '@uppy/react'
import { Container, Loader, Message } from 'semantic-ui-react'
import VideoActions from 'Redux/VideoRedux'
import AwsS3Multipart from '@uppy/aws-s3-multipart'
import DebugConfig from 'Config/DebugConfig'
import { getVideoImage, getVideoSource } from 'Lib/CaptureVideoImage'

const uppy = Uppy({
  autoProceed: false,
  allowMultipleUploads: true,
  restrictions: {
    maxFileSize: null,
    maxNumberOfFiles: 2,
    minNumberOfFiles: 2,
    allowedFileTypes: ['video/*', 'image/*']
  }
})

uppy.use(AwsS3Multipart, {
  // default is "/s3"
  serverUrl: DebugConfig.isDev ? 'http://localhost:3001' : 'https://api.seekrev.com'
})

// New Drag and Drop implementation - Looks buggy (send multiple XHR)
// Once without title which fails
// Then with title which passes
class VideoUpload extends Component {
  state = {
    video: null,
    title: '',
    isUploading: false
  }

  componentWillMount () {
    uppy.on('file-added', this.onFileAdd)
    uppy.on('complete', this.onUploadComplete)
  }

  componentWillUnMount () {
    uppy.of('file-added', this.onFileAdd)
    uppy.off('complete', this.onUploadComplete)
    this.removeUploadedFile()
  }

  componentDidUpdate (prevProps) {
    if (this.props.createData !== prevProps.createData) {
      this.removeUploadedFile()
    }
  }

  removeUploadedFile = () => {
    window.URL.revokeObjectURL(this.state.video)
    this.setState({ video: null, title: '', isUploading: false })
    uppy.cancelAll()
  }

  onFileAdd = file => {
    if (file && file.extension !== 'jpg') {
      this.setState({
        video: URL.createObjectURL(file.data), title: file.name
      }, this.startUpload)
    }
  }

  onUploadComplete = result => {
    if (result.successful.length === 2) {
      const uploadedFileData = result.successful.map(file => {
        return JSON.stringify({
          // extract key without prefix
          id: file.uploadURL.match(/\/cache\/([^?]+)/)[1],
          storage: 'cache',
          metadata: {
            filename: file.name,
            size: file.data.size,
            mime_type: file.data.type,
          }
        })
      })
      this.props.videosCreateRequest({
        title: this.state.title,
        source: uploadedFileData[0],
        poster: uploadedFileData[1],
        projectId: path(['params', 'projectId'], this.props.match)
      })
      this.setState({ isUploading: false })
    }
  }

  startUpload = async () => {
    this.setState({ isUploading: true })
    const video = await getVideoSource(this.state.video)
    const data = getVideoImage(video);
    uppy.addFile({
      name: this.state.title + '.jpg',
      type: 'image/jpeg',
      data,
      source: 'Local'
    })
    uppy.upload()
  }

  render () {
    const loading = this.state.isUploading || this.props.createFetching
    /**
     * Need to add image in the center of the view port when video list is empty
     * to show a message of drag and drop video to upload.
     */
    return (
      <Container>
        <ProgressBar uppy={uppy} fixed />
        <Loader
          active={loading} />
        {!loading && !this.props.dragVideoId && <VideoUploadDragDrop
          uppy={uppy}
          dragVideoId={this.props.dragVideoId}
        />}
        {this.props.createError &&
          <Message color='red'>{this.props.createError}</Message>
        }
      </Container>
    )
  }
}

const mapStateToProps = (state) => ({
  createFetching: state.videos.createFetching,
  createData: state.videos.createData,
  createError: state.videos.createError,
  dragVideoId: state.videos.dragVideoId
})

const mapDispatchToProps = (dispatch) => ({
  videosCreateRequest: (createParams) =>
    dispatch(VideoActions.videosCreateRequest(createParams))
})

export default connect(mapStateToProps, mapDispatchToProps)(VideoUpload)



// WEBPACK FOOTER //
// ./src/Components/VideoUpload/VideoUpload.js